export default "__VITE_ASSET__kg4O4Gvn__"